import { render, staticRenderFns } from "./EditSocialMediaIconComponent.vue?vue&type=template&id=1cd50210&"
import script from "./EditSocialMediaIconComponent.vue?vue&type=script&lang=js&"
export * from "./EditSocialMediaIconComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports